import React, { useMemo, useState, useEffect } from "react"
import moment from "moment"
import ExportExcel from "components/Excelconvert/ExportExcel"
import { useSelector, useDispatch } from "react-redux"
import {
    CardBody,
    Card,
    Row,
    Col,
    Modal,
    UncontrolledTooltip,
    Button,
    Container,
} from "reactstrap"
import { Link, useNavigate } from "react-router-dom"

//import components
import TableContainer from "components/Common/TableContainer"

// slice
import {
    resetEvent,
    editUser,
    fetchEvent,
    deleteEvent,
    activeInactiveEvent,
    PublishEvent,
} from "../../../toolkitStore/eventMSlice/eventSlice"

import Breadcrumbs from "../../../components/Common/Breadcrumb"
import { fetchTicket } from "toolkitStore/ticketMSlice/ticketSlice"

function UpcomingEvents(props) {
    const navigate = useNavigate()
    const dispatch = useDispatch()
    //Delete
    const [modal_backdrop, setmodal_backdrop] = useState(false)
    const [delete_data, SetDelete_data] = useState()
    const [publish_data, SetPublish_data] = useState()
    const [modalFor, SetmodalFor] = useState()

    const { newTicketList, isSuccessfullyAdded } = useSelector(
        state => state.TicketReducer,

    )

    useEffect(() => {
        if (isSuccessfullyAdded) {
            dispatch(fetchTicket())
        }
        dispatch(resetEvent())
    }, [modal_backdrop, isSuccessfullyAdded])
    useEffect(() => {
        localStorage.removeItem("event_id")
        localStorage.removeItem("venue_id")
        dispatch(fetchTicket())
    }, [])

    function removeBodyCss() {
        document.body.classList.add("no_padding")
    }

    function tog_backdrop() {
        setmodal_backdrop(!modal_backdrop)
        removeBodyCss()
    }

    const CloseandCancel = () => {
        // console.log("ii")
        tog_backdrop()
        SetDelete_data()
        SetPublish_data()
    }

    const columns = useMemo(
        () => [
             {
      Header: "Event Name",
      accessor: "event_name",
      Cell: cellProps => {
        return (
          <div style={{ fontWeight: 600 }}>
            {cellProps.row.original.event_name}
          </div>
        )
      },
    },
    {
      Header: "Event Date",
      accessor: "start_date",
      Cell: cellProps => {
        let sd = moment
          .parseZone(cellProps.row.original.start_date)
          .local()
          .format("DD MMM YYYY, hh:mm A")
        return <div>{sd}</div>
      },
    },
            {
      Header: "Event Type",
      accessor: "event_type",
      Cell: cellProps => {
        return (
          <div>
            {cellProps.row.original.event_type?.join(", ")}
          </div>
        )
      },
    },
    {
  Header: "Organizer",
  Cell: cellProps => {
    const organizers = cellProps.row.original.event_organizer || []

    if (organizers.length === 0) return <div>-</div>

    const first = organizers[0]?.organizer_name || "-"
    const remaining = organizers.length - 1

    const fullList = organizers
      .map(o => o.organizer_name)
      .filter(Boolean)
      .join(", ")

    return (
      <div>
        {first}
        {remaining > 0 && (
          <>
            {" "}
            <span
              id={`org-tooltip-${cellProps.row.index}`}
              style={{ color: "blue", cursor: "pointer" }}
            >
              +{remaining} more
            </span>

            <UncontrolledTooltip
              placement="top"
              target={`org-tooltip-${cellProps.row.index}`}
            >
              {fullList}
            </UncontrolledTooltip>
          </>
        )}
      </div>
    )
  },
},
    
            {
                Header: "Number of Days",
                accessor: "no_of_days",
            },
            {
                Header: "Venue",
                filter: false,
                Cell: cellProps => {
                    const SData = cellProps.row.original
                    return (
                        <Link
                            to="/eventvenues"
                            className="btn btn-sm btn-primary"
                            onClick={e => {
                                let PassingData = {
                                    EventName: SData.name,
                                    EventId: SData._id,
                                    EventDay: SData.no_of_days,
                                }
                                // console.log(PassingData)

                                localStorage.setItem("event_id", JSON.stringify(PassingData))
                            }}
                            id="venuetooltip"
                        >
                            Venue
                        </Link>
                    )
                },
            },


        ],
        []
    )
    // console.log(newEventList)

    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid>
                    {/* Render Breadcrumbs */}
                    <Breadcrumbs
                        title="Event Management"
                        breadcrumbItem="Event Management"
                    />

                    <Row className="justify-content-center">
                        <Card>
                            <CardBody className="">
                                <div className="d-flex justify-content-end">
                                    <div className="mb-1 flex-shrink-0">
                                        {/* <ExportExcel excelData={newEventList} fileName={"Event"} /> */}

                                        <Link
                                            to="#!"
                                            onClick={() => {
                                                dispatch(fetchTicket())
                                            }}
                                            className="btn btn-light me-1"
                                        >
                                            <i className="mdi mdi-refresh"></i>
                                        </Link>
                                    </div>
                                </div>
                                <Row>
                                    <div className="container-fluid">
                                        <TableContainer
                                            columns={columns}
                                            data={newTicketList}
                                            isGlobalFilter={true}
                                            isAddOptions={false}
                                            customPageSize={30}
                                            isJobListGlobalFilter={false}
                                            isShowPageSize={false}
                                            isColumnFilterEnabled={false}
                                        // className="custom-header-css"
                                        />
                                    </div>
                                </Row>
                                {newTicketList.length > 7 ? (
                                    <Row>
                                        <Col xs="12">
                                            <div className="text-center my-3">
                                                <Link to="#" className="text-success">
                                                    <i className="bx bx-loader bx-spin font-size-18 align-middle me-2" />
                                                    Load more
                                                </Link>
                                            </div>
                                        </Col>
                                    </Row>
                                ) : null}
                            </CardBody>
                        </Card>
                    </Row>

                    <div>
                        <Modal
                            isOpen={modal_backdrop}
                            toggle={tog_backdrop}
                            backdrop={"static"}
                            id="staticBackdrop"
                        >
                            <div className="modal-header">
                                <h5 className="modal-title" id="staticBackdropLabel">
                                    {modalFor}
                                </h5>
                                <button
                                    type="button"
                                    className="btn-close"
                                    onClick={CloseandCancel}
                                    aria-label="Close"
                                ></button>
                            </div>
                            <div className="modal-body font-size-15">
                                <p>Do you want {modalFor} this Event ?</p>
                            </div>
                            <div className="modal-footer">
                                <button
                                    type="button"
                                    className="btn btn-success"
                                    onClick={() => {
                                        if (modalFor === "Delete") {
                                            dispatch(deleteEvent(delete_data))
                                        } else {
                                            dispatch(PublishEvent(publish_data))
                                        }
                                        tog_backdrop()
                                    }}
                                >
                                    Yes
                                </button>
                                <button
                                    type="button"
                                    className="btn btn-danger"
                                    onClick={CloseandCancel}
                                >
                                    No
                                </button>
                            </div>
                        </Modal>
                    </div>
                </Container>
            </div>
        </React.Fragment>
    )
}

export default UpcomingEvents
